<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">申诉管理</li>
      <el-button
        type="primary"
        :icon="Download"
        link
        @click="state.showAgent = true"
        v-if="$judge_auth('91')"
      >
        从税局更新数据
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-radio-group
        v-model="state.params.is_deal"
        @change="onLoad"
        text-color="#fff"
      >
        <el-radio-button :value="0">待处理</el-radio-button>
        <el-radio-button :value="1" style="--el-button-text-color: #080">
          已处理
        </el-radio-button>
      </el-radio-group>
      <c_withholdingagentselect
        @confirm="(ids) => (state.params.withholding_agent_id = ids)"
      ></c_withholdingagentselect>
      <el-select
        v-model="state.params.tax_bureau_id"
        placeholder="税局"
        style="width: 200px"
      >
        <el-option
          v-for="item in state.taxbureau_data"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-select
        v-model="state.params.sslxdm"
        placeholder="申诉类型"
        style="width: 140px"
      >
        <el-option
          v-for="item in state.appealtype_data"
          :key="item.name"
          :label="item.value"
          :value="item.name"
        />
      </el-select>
      <el-select
        v-model="state.params.sssxdm"
        placeholder="申诉事项"
        style="width: 140px"
      >
        <el-option
          v-for="item in state.appealitem_data"
          :key="item.name"
          :label="item.value"
          :value="item.name"
        />
      </el-select>
      <el-date-picker
        v-model="state.dates"
        type="daterange"
        range-separator="至"
        start-placeholder="限期反馈日期"
        end-placeholder="限期反馈日期"
        value-format="YYYY-MM-DD"
        @change="
          (value) => {
            if (value) state.params.xqfkrq = value[0] + ' - ' + value[1];
          }
        "
        @clear="
          delete state.dates;
          delete state.params.xqfkrq;
        "
      />
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="姓名、证件号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="50"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="处理状态" fixed :width="120">
          <template #default="{ row }">
            <text v-if="row.is_deal == 0">待处理</text>
            <text style="color: #080" v-else>已处理</text>
          </template>
        </el-table-column>
        <el-table-column label="限期反馈日期" width="120">
          <template #default="{ row }">
            <text>{{
              row.xqfkrq ? $dayjs(row.xqfkrq).format("YYYY-MM-DD") : "-"
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :formatter="$tab_TextFormat"
          :min-width="220"
        />
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_TextFormat"
          :min-width="220"
        />
        <el-table-column
          prop="xxbt"
          label="申诉标题"
          :formatter="$tab_TextFormat"
          :min-width="180"
        />
        <el-table-column
          prop="xxnr"
          label="消息内容"
          :formatter="$tab_TextFormat"
          :min-width="300"
        />
        <el-table-column
          prop="xxlx"
          label="消息类型"
          :formatter="$tab_TextFormat"
          width="140"
        />
        <el-table-column
          prop="ssrxm"
          label="申诉人"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="ssrzzlx"
          label="证件类型"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="ssrzzhm"
          label="证件号"
          :formatter="$tab_TextFormat"
          min-width="180"
        />
        <el-table-column
          prop="sssxmc"
          label="申诉事项"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="sslxmc"
          label="申诉类型"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="ssztmc"
          label="申诉状态"
          :formatter="$tab_TextFormat"
          width="140"
        />
        <el-table-column
          prop="lzrq"
          label="离职日期"
          :formatter="(row) => $dayjs(row.lzrq).format('YYYY-MM-DD')"
          width="120"
        />
        <el-table-column
          prop="zccljg"
          label="自查处理结果"
          :formatter="$tab_TextFormat"
          :min-width="180"
        >
          <template #default="{ row }">
            <template v-if="row.zccljg != null">
              <text style="color: #f00" v-if="row.zccljg == 0">申诉不属实</text>
              <text style="color: #1e90ff" v-else>申诉属实</text>
            </template>
            <text>-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="deal_time"
          label="申诉处理日期"
          :formatter="$tab_TextFormat"
          width="180"
        />
        <el-table-column
          prop="bcsm"
          label="补充说明"
          :formatter="$tab_TextFormat"
          :min-width="280"
        />
        <el-table-column
          prop="deal_msg"
          label="处理结果"
          :formatter="$tab_TextFormat"
          :min-width="180"
        />
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template #default="{ row }">
            <el-button
              type="warning"
              link
              icon="Edit"
              @click.stop="
                state.selectItem = row;
                state.showDetail = true;
              "
              v-if="row.is_deal === 0 && $judge_auth('92')"
            >
              处理
            </el-button>
            <el-button
              type="primary"
              link
              icon="Search"
              @click.stop="
                state.selectItem = row;
                state.showDetail = true;
              "
              v-else
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局更新申诉记录"
        @close="state.showAgent = false"
      >
        <c_Agent
          v-if="state.showAgent"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_Agent>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showDetail"
        :title="`来自${state.selectItem?.ssrxm}的申诉`"
        @close="state.showDetail = false"
      >
        <c_PtsMessageDetail
          v-if="state.showDetail"
          @close="state.showDetail = false"
          :id="state.selectItem?.id"
        ></c_PtsMessageDetail>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_taxbureau_select, data_customer_select } from "@/http/data";
import { ptsmessage_list } from "@/http/ptsmessage";
import { appealtype_select, appealitem_select } from "@/http/dictionary";

import c_Agent from "./SelectWithholdingAgent.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    is_deal: 0,
  };
}
export default {
  components: {
    c_Agent,
  },
  setup() {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadCustomer();
      onLoadTaxBureau();
      onLoadAppealtype();
      onLoadAppealitem();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      ptsmessage_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //加载申诉类型
    const onLoadAppealtype = () => {
      appealtype_select().then((res) => {
        if (res.status == 200) state.appealtype_data = res.data.data;
      });
    };

    //加载申诉事项
    const onLoadAppealitem = () => {
      appealitem_select().then((res) => {
        if (res.status == 200) state.appealitem_data = res.data.data;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    //从税局更新数据确认事件
    const onSelectConfirm = () => {
      state.showAgent = false;
      onLoad();
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onLoadTaxBureau,
      onRowClick,
      onSelectConfirm,
    };
  },
};
</script>
<style lang="less"></style>
